import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as channelMetaTransformer } from "./ChannelMeta";
import { fromSqlDateTime } from "../helpers/Date";

export const ChannelValidationSchema = Yup.object().shape({});

export const ChannelObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    title: null,
    is_routable: null,
    hidden: null,
    settings_panel: null,
    created_at: null,
    modified_at: null,
    post_key: null,
    description: null,
    meta: [],
};

/**
 * Transform API object to a ChannelMeta object
 * @param {object} requestData JSON object from the API
 * @returns Object
 */
export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let channel = Object.assign({}, ChannelObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        title: requestData.title,
        slug: requestData.slug,
        is_routable: requestData.is_routable,
        hidden: requestData.hidden,
        settings_panel: requestData.settings_panel,
        created_at: fromSqlDateTime(requestData.created_at),
        modified_at: fromSqlDateTime(requestData.modified_at),
        post_key: requestData.post_key,
        description: requestData.description,
        object_type: "channel",
    });

    if (requestData.meta) {
        let meta = channelMetaTransformer(requestData.meta);
        channel = Object.assign({}, channel, { meta: meta });
    }

    return channel;
}

/**
 * Serialize the content object to a string
 * @param {object} item
 * @returns string
 */
export function serialize(item) {
    return JSON.stringify(item);
}

/**
 * Deserialize json string
 * @param {string} item
 * @returns object
 */
export function deserialize(item) {
    return JSON.parse(item);
}

/**
 *
 * @param {object} item The object being saved
 * @param {object} resetVars Values to overwrite after preparation
 * @returns Object
 */
export function prepare(item, resetVars = {}) {
    return Object.assign(
        {},
        item,
        {
            object_type: undefined,
        },
        resetVars
    );
}
